import { render, staticRenderFns } from "./RepInscritos.vue?vue&type=template&id=b92d0e1e&"
import script from "./RepInscritos.vue?vue&type=script&lang=js&"
export * from "./RepInscritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports